<header class="modal-header header">
  <svg class="light icon">
    <use [attr.xlink:href]="'/assets/images/issue-actions/sprite.svg#'+jobType+'-Thick'"></use>
  </svg>

  {{ (isEditing ? Localization.EditAction : Localization.AddAction) | translate }}

  <a (click)="cancel()" aria-label="Close" class="close pull-right">
    <span aria-hidden="true">×</span>
  </a>
</header>
<main>

  <h5>Job</h5>
  <section class="job">

    <chapps-select-input
      [bindValue]="null"
      [control]="jobForm.controls.interventionTeam"
      [items]="executorOptions$ | async"
      [label]="Localization.Executor"
      [loading]="loading.executors"
      [placeholder]="Localization.Executor"
      [readOnly]="!canChangeExecutor">
    </chapps-select-input>

    <ng-container *ngIf="wantsNewExecutor">
      <chapps-text-input
        [control]="executorForm.controls.label"
        [label]="Localization.NewExecutorName | translate"
        [placeholder]="Localization.NewExecutorName | translate">
      </chapps-text-input>

      <chapps-text-input
        [control]="executorForm.controls.email"
        [label]="Localization.NewExecutorEmail | translate"
        [placeholder]="Localization.NewExecutorEmail | translate">
      </chapps-text-input>
    </ng-container>


    <chapps-select-input
      [control]="jobForm.controls.type"
      [items]="jobTypeOptions"
      [label]="Localization.TypeOfJob"
      [placeholder]="Localization.TypeOfJob"></chapps-select-input>

    <chapps-text-area-input
      [control]="jobForm.controls.instructions"
      [label]="Localization.Directive | translate | titlecase">
    </chapps-text-area-input>

    <chapps-date-picker-input
      [control]="jobForm.controls.dueDate"
      [culture]="culture"
      [customDatePickerOptions]="{ closeAfterSelect: true }"
      [label]="Localization.DueDate | translate"
      [placeholder]="Localization.DueDate | translate">
    </chapps-date-picker-input>

    <ng-container *ngIf="this.hasMaintenanceProduct">
      <chapps-text-input
        [control]="jobForm.controls.reference"
        [label]="Localization.InvoiceNumber | translate | titlecase"
        [placeholder]="Localization.InvoiceNumber | translate | titlecase">
      </chapps-text-input>
      <chapps-text-input
        [control]="jobForm.controls.workOrderReference"
        [label]="Localization.WorkOrderReference | translate | titlecase"
        [placeholder]="Localization.WorkOrderReference | translate | titlecase">
      </chapps-text-input>
      <chapps-switch (change)="jobForm.markAsDirty()"
                     [control]="jobForm.controls.urgency"
                     [labels]="[Localization.Urgent | translate, Localization.NotUrgent | translate]"
                     [values]="[Urgency.URGENT, false]"
                     class="half-size"></chapps-switch>
      <chapps-number-input [control]="jobForm.controls.priority"
                           [label]="'Priority'"
                           [max]="3"
                           [min]="0"
                           class="half-size"></chapps-number-input>
    </ng-container>
  </section>

  <ng-container *ngIf="canShowIssueDetails">
    <h5>Issue details</h5>
    <section class="issue">

      <chapps-text-input [control]="issueForm.controls.building"
                         [label]="Localization.Building"></chapps-text-input>

      <chapps-text-input [control]="issueForm.controls.location"
                         [label]="Localization.Location"></chapps-text-input>


      <chapps-text-input [control]="issueForm.controls.element"
                         [label]="Localization.Element"></chapps-text-input>

    </section>
  </ng-container>

</main>

<footer class="modal-footer justify-content-end">
  <chapps-secondary-button (clicked)="save()"
                           [disabled]="!canSave"
                           [label]="Localization.Save"
                           [loading]="loading.saving"
                           [small]="true">
  </chapps-secondary-button>
  <chapps-secondary-button (clicked)="saveAndSend()"
                           [disabled]="!canSave || !canSend"
                           [label]="Localization.SaveAndSend"
                           [loading]="loading.saving"
                           [small]="true">
  </chapps-secondary-button>
</footer>
